'use client'

import { PrimaryAction } from '@ethena/shared-ui/src/components/PrimaryAction'
import { DAPP_URL } from '@ethena/shared-ui/src/constants/url'
import { cn } from '@ethena/shared-ui/utils'
import Link from 'next/link'

export const Hero = ({ isGerman }: { isGerman: boolean }) => {
  const title = isGerman ? (
    <span>
      <span>USDe:&nbsp;</span>
      <span>Enabling Internet Money</span>
    </span>
  ) : (
    <span>
      <span>Digital Dollars for the&nbsp;</span>
      <br className="hidden lg:block" />
      <span>Internet Economy</span>
    </span>
  )

  return (
    <div className="w-fit z-20 my-16 animate-in slide-in-from-bottom-8 duration-700 mx-2 max-w-[700px] relative self-center">
      <div className="flex-1 flex flex-col justify-center gap-5">
        <h1
          className={cn(
            'min-h-[76px] xxs-max:min-h-[113px] sm:min-h-[125px] md:min-h-[144px] gradient-text text-[2.5rem] sm:text-[3rem] md:text-[4rem] leading-tight md:leading-[4.5rem] font-medium',
            isGerman && 'mb-10',
          )}
        >
          {title}
        </h1>
        {!isGerman && (
          <Link href={DAPP_URL + '/buy'} target="_blank" className="w-fit">
            <PrimaryAction size="large">Earn with USDe</PrimaryAction>
          </Link>
        )}

        {isGerman && (
          <div className="flex flex-col gap-2 overflow-y-auto w-fit">
            <div className="text-text-primary">
              <h2 className="w-full sm:w-[420px] mb-1 underline">Imprint</h2>
              <p className="text-xs w-full sm:w-[420px]">
                <span>Ethena GmbH, Friedrich-Ebert-Anlage 49, 60308 Frankfurt am Main</span>
                <br />
                <span>Email: finance@ethena.gmbh</span>
                <br />
                <span>Commercial Register: District Court of Frankfurt, HRB 136862</span>
                <br />
                <span>
                  Supervisory Authority: Bundesanstalt für Finanzdienstleistungsaufsicht, Marie-Curie-Straße 24-28,
                  60439 Frankfurt am Main
                </span>
                <br />
                <span>Managing Director: Guy Young and Torsten Luettich</span>
                <br />
                <span>Responsible for Content: Torsten Luettich</span>
                <br />
                <span>
                  The European Commission provides a platform for online dispute resolution (OS) at
                  http://ec.europa.eu/consumers/odr. We are not obliged nor willing to participate in an online dispute
                  resolution procedure.
                </span>
                <br />
              </p>
            </div>
            <div className="text-text-primary">
              <h2 className="w-full sm:w-[420px] mb-1 underline">Impressum</h2>
              <p className="text-xs w-full sm:w-[420px]">
                <span>Ethena GmbH, Friedrich-Ebert-Anlage 49, 60308 Frankfurt am Main</span>
                <br />
                <span>Email: finance@ethena.gmbh</span>
                <br />
                <span>Handelsregister: AG Frankfurt am Main, HRB 136862</span>
                <br />
                <span>
                  Regulierunsbehörde: Bundesanstalt für Finanzdienstleistungsaufsicht, Marie-Curie-Straße 24-28, 60439
                  Frankfurt am Main
                </span>
                <br />
                <span>Geschäftsführer: Guy Young and Torsten Luettich</span>
                <br />
                <span>Verantwortlich für journalistisch-redaktionelle Angebote: Torsten Luettich</span>
                <br />
                <span>
                  Die Europäische Kommission stellt unter http://ec.europa.eu/consumers/odr eine Plattform zur
                  Online-Streitbeilegung (OS) bereit. Wir sind nicht verpflichtet und nicht bereit, an einem Verfahren
                  zur Online-Streitbeilegung teilzunehmen.
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
